import React, { useEffect, useState } from 'react'
import AddButtonPage from '../../../../Components/AddButtonPage/AddButtonPage'
import MentorRequirement from './MentorRequirement'
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { MentorRequirementPostAction } from '../../../../ReduxStore/Slices/MentorRequirement/MentorRequirementPost';
import { MentorRequirementGetAllAction } from '../../../../ReduxStore/Slices/MentorRequirement/MentorRequirementGetAll';
import { toast } from 'react-toastify';

const MentorRequirementHome = () => {


  // const tableData = [
  //   { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
  //   { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
  //   { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
  //   { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },


  // ];

  const { updateMentorRequirement } = useSelector(state => state?.updateMentorRequirement);
  const { deleteMentorRequirement } = useSelector(state => state?.deleteMentorRequirement);



  const tableData = [
    {
      campusName: "Cygnusa",
      role: "Jury Member",
      expertise: "Robotics",
      vacancies: 3,
      evenetStartDate: "28-12-2025",
      evenetEndDate: "30-12-2025",
      requirements: "Ph.D. in Robotics, 5+ years experience"
    },
    {
      campusName: "Cygnusa",
      role: "Expert Lecture",
      expertise: "AI & ML",
      vacancies: 2,
      evenetStartDate: "15-01-2026",
      evenetEndDate: "17-01-2026",
      requirements: "M.Tech with 3+ years in AI"
    },
    {
      campusName: "Cygnusa",
      role: "Mentor",
      expertise: "Cloud Computing",
      vacancies: 1,
      evenetStartDate: "10-02-2026",
      evenetEndDate: "12-02-2026",
      requirements: "AWS Certified, 4+ years experience"
    },
    {
      campusName: "Cygnusa",
      role: "Expert Lecture",
      expertise: "Cybersecurity",
      vacancies: 2,
      evenetStartDate: "05-03-2026",
      evenetEndDate: "07-03-2026",
      requirements: "Ethical Hacking Certification, 3+ years"
    }
  ];

  const tableHeadData = ['S.No', 'Campus Name', 'Jury Member/ Expert Lecture/ Mentor', "Expertise", "Number of vacancies", "Starting Date", "Closing Date", "Reuirements Details", "Actions"]



  const dispatch = useDispatch();

  const { MentorRequirementGetAll } = useSelector(state => state?.MentorRequirementGetAll);
  console.log(MentorRequirementGetAll, "EventGetAllEventGetAll")
  const { MentorRequirementPost } = useSelector(
    (state) => state?.MentorRequirementPost
  );

  const [rowTableData, setRowTableData] = useState([])
  console.log(rowTableData, "rowTableTAdatatattattat")

  useEffect(() => {
    const fetchData = async () => {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllMentorRequirements`,
      };

      const responseData = await dispatch(actions.MENTORREQUIREMENTGETALL(data1));
      console.log(responseData, "responseDataaa")
      // setResponseTableData(responseData?.payload)

    }


    fetchData();

  }, [MentorRequirementPost,updateMentorRequirement,deleteMentorRequirement]);

  useEffect(() => {
    const tempArr = [];

    MentorRequirementGetAll?.data?.map((data, index) => {
      return tempArr.push({
        id: data?.mentor_id,
        campusName: data?.campus_requirement || '--',
        mentor: data?.mentor_type || '--',
        expertise: data?.expertise || '--',
        no_of_vacanies: data?.vacancies || "",

        startDate: data?.from_date || '--',
        closingDate: data?.to_date || '--',
        requirement_details: data?.requirements || ""

      });
    });
    setRowTableData(tempArr);


  }, [MentorRequirementGetAll]);

  const handleDeleteById = async (id) => {
    const data1 = {
      data: {},
      method: "delete",
      apiName: `deleteMentorRequirement/${id}`,
    };

    const responseData = await dispatch(actions.DELETEMENTORREQURIEMENT(data1));
    if (responseData?.payload?.message === "Mentor requirement deleted successfully.") {
      toast.success(responseData?.payload?.message)

    } else {
      toast.error(responseData?.payload?.message)


    }


  }


  return (
    <div>

      <AddButtonPage addComponent={MentorRequirement} handleDeleteById={handleDeleteById} title="Jury member/ expert lecture/ mentor requirement" tableData={rowTableData} tableHeadData={tableHeadData} />
    </div>
  )
}

export default MentorRequirementHome 